import { useContext, useState } from "react";
import { AppContext } from "../Context";

function ParamStitch() {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const colors = [
        { id: "blue", color: "monogram-blue.png" },
        { id: "lightBlue", color: "monogram-lightBlue.png" },
        { id: "brown", color: "monogram-brown.png" },
        { id: "gold", color: "monogram-gold.png" },
        { id: "white", color: "monogram-white.png" },
        { id: "gray", color: "monogram-gray.png" },
        { id: "black", color: "monogram-black.png" },
        { id: "navy", color: "monogram-navy.png" },
        { id: "green", color: "monogram-green.png" },
        { id: "red", color: "monogram-red.png" },
        { id: "burgundy", color: "monogram-burgundy.png" },
        { id: "lavender", color: "monogram-lavender.png" },
        { id: "lightPink", color: "monogram-lightPink.png" },
        { id: "pink", color: "monogram-pink.png" },
        { id: "orange", color: "monogram-orange.png" },
        { id: "purple", color: "monogram-purple.png" }
    ];

    function onColorClick(id) {
        dispatch({ type: "SET_STITCH_COLOR", payload: id })
        dispatch({ type: "SET_STITCH", payload: true })
        dispatch({ type: "SET_STITCH_PRICE", payload: 10 });
        dispatch({ type: "SET_DONE", payload: true });
    }

    function removeColor() {
        dispatch({ type: "SET_STITCH_COLOR", payload: null })
        dispatch({ type: "SET_STITCH", payload: false })
        dispatch({ type: "SET_STITCH_PRICE", payload: 0 });
        dispatch({ type: "SET_DONE", payload: true });
    }

    return (
        <div className="paramItem">
            <div className="paramHeader">
                <div className="paramTitle">Button Hole Stitch</div>
                <div className="paramPrice">+$10</div>
            </div>
            <div className="monoList">
                {colors.map((color) => (
                    <div key={color.id} className="monoBtnColor">
                        <img onClick={() => onColorClick(color.id)} className="monoImgColor" src={`${process.env.PUBLIC_URL}/images/${color.color}`} width={80} alt={color.id} />
                        <div className="monoColorName">{color.id}</div>
                        {state.stitchColor === color.id && (
                            <img className="tickWhite" src={process.env.PUBLIC_URL + "/images/tickWhite.svg"} alt="selected" />
                        )}
                    </div>
                ))}
            </div>
            <div style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                <div onClick={removeColor} className="paramButtons">Remove</div>
            </div>
        </div>
    )
}
export default ParamStitch